export default __webpack_public_path__ + "static/media/medical-recreational-cover.07999208.jpg";